import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Cpu } from "lucide-react";

export default function AiModelsTab() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/admin/ai-models").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="text-sm text-neutral-500">Loading AI settings…</div>;

  const change = async (featureKey, value) => {
    setSaving(true);
    try {
      const { data: next } = await api.put("/admin/ai-models", { models: { [featureKey]: value } });
      setData(next);
      const opt = next.options.find((o) => o.value === value);
      toast.success(`${next.features.find((f) => f.key === featureKey)?.label} now uses ${opt?.label}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not save");
    } finally { setSaving(false); }
  };

  return (
    <div className="space-y-8 max-w-3xl" data-testid="ai-models-tab">
      <div className="flex items-start gap-4 border hairline bg-[color:var(--brand-surface2)] p-5">
        <Cpu size={18} className="text-[var(--brand-primary)] mt-0.5" />
        <div className="text-sm text-neutral-600 leading-relaxed">
          Choose which AI model powers each feature in this workspace. Both run on your Emergent universal key —
          switch anytime, changes apply to the next conversation.
        </div>
      </div>

      <div className="border hairline bg-white divide-y divide-neutral-100">
        {data.features.map((f) => (
          <div key={f.key} className="p-5 flex flex-wrap items-center justify-between gap-4">
            <div>
              <div className="text-sm font-medium">{f.label}</div>
              <div className="text-xs text-neutral-500 mt-0.5">{f.desc}</div>
            </div>
            <select value={f.current} disabled={saving} data-testid={`ai-model-select-${f.key}`}
                    onChange={(e) => change(f.key, e.target.value)}
                    className="border hairline bg-white px-3 py-2 text-sm focus:outline-none focus:border-[color:var(--brand-primary)]">
              {data.options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </div>
        ))}
      </div>
    </div>
  );
}
